<script setup>
import { onMounted, onUnmounted } from "vue";
import { useInitializeStore } from '@/stores/initialize';

const initializeStore = useInitializeStore();

onMounted(() => {
	initializeStore.addMenuPixel()
});

onUnmounted(() => { 
	initializeStore.removeMenuPixel()
})

</script>

<template>
	<router-view></router-view>
</template>
